export const toUTCDate = (utcDateStr) => {
  let date;
  try {
    date = new Date(`${utcDateStr}Z`); // grp server times omits timezone info
  } catch (err) {
    console.error("Unable to parse utc date:", utcDateStr, err);
  }
  return date;
};

export const toUTCYYYYMMDD = (date) => date && date.toISOString && date.toISOString().split("T")[0];

export const dateToLocaleString = (date, lang = "en") =>
  date.toLocaleDateString &&
  date
    .toLocaleString(lang, {
      day: "numeric",
      year: "numeric",
      month: "short",
    })
    .toUpperCase();

export const dateToLocaleDateTimeString = (date, lang = "en") =>
  date.toLocaleDateString &&
  date
    .toLocaleString(lang, {
      day: "numeric",
      year: "numeric",
      month: "short",
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    })
    .toUpperCase();

export const dateToLocaleStringMMMyyyy = (date, lang = "en") =>
  date.toLocaleDateString && date.toLocaleString(lang, { year: "numeric", month: "short" }).toUpperCase();

export const toLocaleYYYYMMDD = (date) =>
  date &&
  date.getDate &&
  [date.getFullYear(), `0${date.getMonth() + 1}`.slice(-2), `0${date.getDate()}`.slice(-2)].join("-");

export const todayMinusDays = (days) => {
  const date = new Date();
  const pastDate = date.getDate() - days;
  date.setDate(pastDate);
  return toUTCYYYYMMDD(date);
};

export const addDaysToDate = (days, date) => {
  if (!date || !date.getDate) return null;
  if (!days) return date;
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const earliestDate = (date1 = null, date2 = null) => {
  if (!date1 && !date2) return null;
  if (!date1 || !date2) return date1 || date2;
  return date1.getTime() < date2.getTime() ? date1 : date2;
};
